import { UploadService } from './../../Services/upload.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ClothesService } from './../../Services/clothes.service';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-clothes-admin-form',
  template: require('./clothes-admin-form.component.html'),
  styles: [require('./clothes-admin-form.component.css')]
})
export class ClothesAdminFormComponent implements OnInit {
  @ViewChild("fileInput") fileInput: ElementRef;
  clothes: any = {
    id: 0,     
    description:"",
    price:"",
    image:"",
    title:"",
    isMale:false,
    isFemale:false
  };

  constructor(
      private clothesService: ClothesService, 
      private route: ActivatedRoute, 
      private router: Router, 
      private uploadService: UploadService) { 
    route.params.subscribe(p => {
      if (p['id'])
        this.clothes.id = +p['id'];
      else
        this.clothes.id = 0;
    });
  }

  ngOnInit() {
    if (this.clothes.id > 0) {
      this.clothesService.getClothesById(this.clothes.id).subscribe( c => {
        this.clothes = c
      }, err => {
        if (err.status == 404) {
          console.log(err);
          console.log(this.clothes.id);
        }
        if (err.status == 403) {
          this.router.navigate(['/home']);
        }
      });
    }
  }
  
  submit(){
    if (this.clothes.id > 0){
      this.clothesService.update(this.clothes).subscribe ( res => {
      })
    } else{
        this.clothesService.save(this.clothes).subscribe( res => {
        })
    }
    this.router.navigate(['/clothes/list']);
  }

  getClothById(id:number){
    this.clothesService.getClothesById(id).subscribe( res => {
      this.clothes = res;
    })
  }

  delete(id:number){
    Swal.fire({
      title: 'Ben je zeker?',
      text: "Ben je zeker dat je dit wil verwijderen?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Jep',
      cancelButtonText: 'Nope'
    }).then((result) => {
      if (result.value) {
        this.clothesService.delete(id).subscribe( x => {
          this.router.navigate(['/clothes/list']);
        })
      }
    });
  }

  uploadPhoto() {
    var nativeElement: HTMLInputElement = this.fileInput.nativeElement;
    if (nativeElement != null) {
      var files = nativeElement.files;
      if (files != null) {
        var file = files[0];
        this.uploadService.uploadClothesPicture(file).subscribe(x => {
          this.clothes.image = x.filename;
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/clothes-admin-form/clothes-admin-form.component.ts